
export default {
    name: 'prestation',
    components: {},
    props: {
        prestations: Array,
        prestation_index: Number,
        montant_total: Number,
        detail_empty: {
            type: Boolean,
            default: false
        },
        detail_loading: {
            type: Boolean,
            default: false
        },
        detail_error: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            fields: [
                { key: 'libelle', label: 'Libellé' }, { key: 'qte', label: 'Qté' },  'montant'
            ],
            fields_patient: [
                { key: 'num_dossier', label: 'N° dossier' }, 
                'patient', 'sexe', { key: 'telephone', label: 'Téléphone' },
                'qte', 'montant'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            liste_patients: [],
            modal_index: 0,
        }
    },

    watch: {
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        viewPatient(data, index) {
            this.liste_patients = data.patients
            this.modal_index = index
        },
    }
}


